import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

// Gate for the consultant affiliate area — the only page consultant accounts
// can use (see AppRoute / RequireSubscription, which send them here).
const RequireConsultant = ({ children }) => {
  const { user, loading, isConsultant, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (!isConsultant) return <Navigate to={isAdmin ? '/admin' : '/dashboard'} replace />;

  return children;
};

export default RequireConsultant;
